import { gql } from '@apollo/client'

export const ADMIN_RESET_PASSWORD_MUTATION = gql`
  mutation adminResetPassword($input: AdminResetPasswordInput!) {
    adminResetPassword(input: $input) {
      id 
      email
      activated_at
    }
  }
`